import React from "react";
import { Offcanvas, Stack } from "react-bootstrap";
import { useCartContext } from "../context/CartContext";
import CartItem from "./CartItem";
import FormatCurrency from "./FormatCurrency";
import storeItems from "../data/StoreData.json";
import {Link} from 'react-router-dom'
const ShoppingCart = ({ isOpen }) => {
  const { closeCart, CartItems } = useCartContext();
  return (
    <Offcanvas show={isOpen} onHide={closeCart} className="cartcontainer" placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Cart</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="cartbody">
        <Stack gap={3}>
          {CartItems.map((item) => (
            <CartItem key={item.id} {...item} />
          ))}
          <div className="ms-auto  fw-bold fs-5 price">
            Total{" "}
            {FormatCurrency(
              CartItems.reduce((total, cartItem) => {
                const item = storeItems.find((i) => i.id === cartItem.id);
                return total + (item?.price || 0) * cartItem.quantity;
              }, 0)
            )}
          </div>
        </Stack>
        <ul>
          <li> <Link className="vCart" to="/CartPage" > Viwe Cart </Link> </li>
          <li> <Link className="vCheckout" to="/Checkout" > Checkout </Link> </li>
        </ul>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ShoppingCart;